<!-- 全局Loading -->
<template>
    <div class="lading">
        <div class="loadCont">
            <van-loading color="#E02020" type="spinner" ></van-loading>
        </div>
    </div>
</template>

<script>
import { Loading } from 'vant';
export default {
    data () {
        return {
            
        };
    },
    components: {
        [Loading.name]:Loading,
    },
    methods: {}
}

</script>
<style scoped>
.lading{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 999;
}
.loadCont{
    width: 140px;
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,.2);
    border-radius: 8px;
}
</style>